/**
 * @description Service to enable or disable features for particular environments
 * @author Cameron Woodmansee
 */

const Feature = require('@wpmedia/arc-features');

async function getFeatures(flags, debug) {
  return Feature.default.instance({
    flags,
    debug
  });
}

function featureFlag(localDev) {
  const flags = {
    tasksv2: {
      default: false,
      enabled: ['*:*']
    },
    editorialSearchApi: {
      default: false,
      enabled: []
    }
  };

  const service = {
    features: getFeatures(flags, localDev)
  };

  service.isEnabled = async (feature) =>
    (await service.features).isEnabled(feature);
  service.isDisabled = async (feature) =>
    (await service.features).isDisabled(feature);

  return service;
}

module.exports = (ngModule) => {
  ngModule.factory('featureFlag', ['localDev', featureFlag]);
};
